export const CAMPAIGN_TABLE_COLUMNS = [
    {
        title: 'Campaign Name',
        sortable: false,
        key: 'campaignName',
        width: '12.5%',
    },
    {
        title: 'Pacing',
        sortable: false,
        key: 'pacingEnabled',
        width: '12.5%',
    },
    {
        title: 'Starts on',
        sortable: false,
        key: 'startDate',
        width: '12.5%',
    },
    {
        title: 'Ends on',
        sortable: false,
        key: 'endDate',
        width: '12.5%',
    },
    {
        title: 'Budget',
        sortable: true,
        key: 'budget',
        width: '12.5%',
    },
    {
        title: 'Spend',
        sortable: true,
        width: '12.5%',
        key: 'spend',
    },
    {
        title: 'ROI',
        sortable: true,
        width: '12.5%',
        key: 'roi',
    },
];
